import React, { useState } from 'react';
import HeaderCalender from './HeaderCalender';
// import BiListImage from '../../../../../assets/patientCharts/bi_list (1).svg'
// import MaterialSymbolsImage from '../../../../../assets/patientCharts/material-symbols-light_view-cozy-outline.svg'
// // bi_list (1).svg
// import calendericon from '../../../../../assets/patientCharts/calendericon.svg'
// import BasicDateCalendar from './Calendar';
const formatDate = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}.${day}.${year}`;
};
const PatientHeader = ({handleView , viewStatus ,setSearchDate , searchDate}) => {
  
    const Label = () => {
    return (
      <div className="w-[72px] h-[17px] items-center">
        <div className=" h-[17px] top-0 left-0 [font-family:'Inter-SemiBold',Helvetica] font-semibold text-[#3a405b] text-xl tracking-[1.00px] leading-[17px] whitespace-nowrap">
          Orders
        </div>
      </div>
    );
  };
 
  return (
    <div className=' flex justify-between align-center items-center pt-3 pb-2 pr-4'>
      <Label />
      <div className='flex'>
        <HeaderCalender handleView ={handleView} view={viewStatus}  searchDate={searchDate} setSearchDate={setSearchDate}/>
      </div>
    </div>
  );
};

export default PatientHeader;
